import { IImageProps, Image } from "native-base";
import fjss from "fast-json-stable-stringify";

export function CacheFixedImage(props: IImageProps) {
  return <Image key={fjss(props.source)} source={props.source} {...props} />;
}
